
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/order-for-delivery/[category]",
      function () {
        return require("private-next-pages/[slug]/order-for-delivery/[category].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/order-for-delivery/[category]"])
      });
    }
  